<template>
  <div>
    <Collapse v-model="isOpen">
      <Panel name="open">
        内容配置
        <div slot="content">
          <el-form
            ref="formCustom"
            :inline="true"
            label-width="125px"
            :model="contentInfo"
          >
            <el-form-item label="完整原音: ">
              <el-row type="flex" class="row-bg" style="width: 450px">
                <el-col
                  :span="10"
                  v-if="
                    contentInfo.audio != undefined && contentInfo.audio != ''
                  "
                >
                  <AudioPlayer :audioUrl="contentInfo.audio"></AudioPlayer>
                </el-col>
                <el-col
                  :span="5"
                  v-if="
                    contentInfo.audio != undefined && contentInfo.audio != ''
                  "
                >
                  <span
                    v-if="contentInfo.duration != null"
                    style="
                      font-size: 13px;
                      margin-right: 10px;
                      margin-left: 10px;
                    "
                    >时长：{{ contentInfo.duration }}秒</span
                  >
                </el-col>
                <el-col :span="5">
                  <Upload
                    action="/aries-api/resource/upload"
                    accept="audio/mp3"
                    :before-upload="onBeforeAudioUpload"
                    :on-success="onSuccessAudioUpload"
                    :data="uploadDataAudio"
                    :show-upload-list="false"
                    :disabled="doWhatTemp === 'view'"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      :disabled="doWhatTemp === 'view'"
                    >
                      上传
                      <i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                  </Upload>
                </el-col>
                <el-col
                  :span="4"
                  v-if="
                    contentInfo.audio != undefined && contentInfo.audio != ''
                  "
                >
                  <el-button
                    size="small"
                    type="danger"
                    @click="delAudio"
                    icon="el-icon-delete"
                    :disabled="doWhatTemp === 'view'"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-form-item>
            <br />
            <el-form-item label="讲解者: ">
              <el-input
                v-model="contentInfo.artist"
                :disabled="doWhatTemp === 'view'"
                placeholder=""
              ></el-input>
            </el-form-item>
            <br />

            <el-form-item label="完整讲解: ">
              <el-row type="flex" class="row-bg" style="width: 450px">
                <el-col
                  :span="10"
                  v-if="
                    contentInfo.explainAudio != undefined &&
                    contentInfo.explainAudio != ''
                  "
                >
                  <AudioPlayer
                    :audioUrl="contentInfo.explainAudio"
                  ></AudioPlayer>
                </el-col>
                <el-col
                  :span="5"
                  v-if="
                    contentInfo.explainAudio != undefined &&
                    contentInfo.explainAudio != ''
                  "
                >
                  <span
                    v-if="contentInfo.explainDuration != null"
                    style="
                      font-size: 13px;
                      margin-right: 10px;
                      margin-left: 10px;
                    "
                    >时长：{{ contentInfo.explainDuration }}秒</span
                  >
                </el-col>
                <el-col :span="5">
                  <Upload
                    action="/aries-api/resource/upload"
                    accept="audio/mp3"
                    :before-upload="onBeforeAudioUpload"
                    :on-success="onSuccessExplainAudioUpload"
                    :data="uploadDataAudio"
                    :show-upload-list="false"
                    :disabled="doWhatTemp === 'view'"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      :disabled="doWhatTemp === 'view'"
                    >
                      上传
                      <i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                  </Upload>
                </el-col>
                <el-col
                  :span="4"
                  v-if="
                    contentInfo.explainAudio != undefined &&
                    contentInfo.explainAudio != ''
                  "
                >
                  <el-button
                    size="small"
                    type="danger"
                    @click="delExplainAudio"
                    icon="el-icon-delete"
                    :disabled="doWhatTemp === 'view'"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="讲解者: " v-if="false">
              <el-input
                style="width: 300px"
                v-model.trim="contentInfo.artist"
                :disabled="doWhatTemp === 'view'"
              />
            </el-form-item>
            <br />
            <el-form-item label="视频: ">
              <el-row type="flex" class="row-bg" style="width: 450px">
                <el-col :span="15" v-if="contentInfo.video != ''">
                  <video
                    ref="vidioPlayer"
                    :src="contentInfo.video"
                    controls="controls"
                    width="270"
                  >
                    浏览器不支持video
                  </video>
                </el-col>
                <el-col :span="5">
                  <Upload
                    action="/aries-api/resource/upload"
                    accept="video/mp4"
                    :before-upload="onBeforeVideoUpload"
                    :on-success="onSuccessVideoUpload"
                    :data="uploadData"
                    :show-upload-list="true"
                    :disabled="doWhatTemp === 'view'"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      :disabled="doWhatTemp === 'view'"
                    >
                      上传
                      <i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                  </Upload>
                </el-col>
                <el-col :span="4" v-if="contentInfo.video != ''">
                  <el-button
                    size="small"
                    type="danger"
                    @click="delVideo"
                    icon="el-icon-delete"
                    :disabled="doWhatTemp === 'view'"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="视频封面: ">
              <el-row type="flex" class="row-bg" style="width: 300px">
                <el-col :span="9" v-if="contentInfo.poster != ''">
                  <img :src="contentInfo.poster" width="80px" height="80px" />
                </el-col>
                <el-col :span="7">
                  <Upload
                    action="/aries-api/resource/upload"
                    accept="image/jpeg, image/gif, image/png"
                    :before-upload="onBeforeUpload"
                    :on-success="onSuccessPosterUpload"
                    :data="uploadData"
                    :show-upload-list="false"
                    :disabled="doWhatTemp === 'view'"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      :disabled="doWhatTemp === 'view'"
                    >
                      上传
                      <i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                  </Upload>
                </el-col>
                <el-col :span="8" v-if="contentInfo.poster != ''">
                  <el-button
                    size="small"
                    type="danger"
                    @click="delVideoCover"
                    icon="el-icon-delete"
                    :disabled="doWhatTemp === 'view'"
                    >删除</el-button
                  >
                </el-col>
              </el-row>
            </el-form-item>
            <br />
            <el-form-item label="显示模式: " v-if="false">
              <el-tooltip
                effect="dark"
                content="上传的书每页一张图为单页模式，每页有左右两张图为双页模式"
                placement="top-start"
              >
                <el-select
                  v-model="contentInfo.mode"
                  :disabled="doWhatTemp === 'view'"
                  style="width: 150px"
                >
                  <el-option
                    v-for="item in modeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
            <br />
          </el-form>
        </div>
      </Panel>
    </Collapse>
  </div>
</template>

<script>
import AudioPlayer from "../AudioPlayer";
import { checkFormat } from "../../book";
export default {
  name: "addBookContent",
  components: { AudioPlayer },
  data() {
    return {
      uploadData: {
        isOnlyMP3: "false",
        pdfToPng: "false",
      },
      uploadDataAudio: {
        isOnlyMP3: "true",
        pdfToPng: "false",
      },
      modeList: [
        {
          value: 0,
          label: "APP拼页",
        },
        {
          value: 1,
          label: "APP不拼页",
        },
      ],
      isOpen: "open",
    };
  },
  created() {},
  props: {
    contentInfo: {
      type: Object,
      default() {
        let temp = {
          duration: null,
          audio: "",
          explainAudio: "",
          explainDuration: null,
          artist: "",
          video: "",
          poster: "",
          videoDuration: null,
          mode: 0,
        };
        return temp;
      },
    },
    doWhatTemp: {
      type: String,
      default: "",
    },
  },
  watch: {},
  methods: {
    onBeforeAudioUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传文件大小不能超过50MB!");
      }
      return isLt50M;
    },
    onSuccessAudioUpload(response, file, fileList) {
      console.log(response);
      if (response.result == 0) {
        this.contentInfo.audio = response.data[0].url;
        this.contentInfo.duration = response.data[0].length;
        this.$Message.success("上传成功!");
      } else {
        alert(response.msg);
      }
    },
    delAudio() {
      this.contentInfo.audio = "";
      this.contentInfo.duration = null;
    },
    onSuccessExplainAudioUpload(response, file, fileList) {
      console.log(response);
      if (response.result == 0) {
        this.contentInfo.explainAudio = response.data[0].url;
        this.contentInfo.explainDuration = response.data[0].length;
        this.$Message.success("上传成功!");
      } else {
        alert(response.msg);
      }
    },
    delExplainAudio() {
      this.contentInfo.explainAudio = "";
      this.contentInfo.explainDuration = null;
    },
    onBeforeUpload(file) {
      if (!checkFormat(file, "picture")) {
        return false;
      }
    },
    onBeforeVideoUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传文件大小不能超过50MB!");
      }
      return isLt50M;
    },
    onSuccessVideoUpload(response, file, fileList) {
      console.log(response);
      if (response.result == 0) {
        this.contentInfo.video = response.data[0].url;
        this.contentInfo.videoDuration = response.data[0].length;
        //if (this.formCustom.poster == "") {
        this.contentInfo.poster = response.data[0].poster;
        //}
        this.$Message.success("上传成功!");
      } else {
        alert(response);
      }
    },
    onSuccessPosterUpload(response, file, fileList) {
      console.log(response);
      this.contentInfo.poster = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    delVideo() {
      this.contentInfo.video = "";
      this.contentInfo.videoDuration = null;
    },
    delVideoCover() {
      this.contentInfo.poster = "";
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// addBookContent.vue?cad2a44a